import { Reveal, Eyebrow } from "./Reveal";
import { IMAGES } from "@/lib/site";

export const About = () => (
  <section id="about" data-testid="about-section" className="relative bg-obsidian py-16 sm:py-24 lg:py-32 border-t border-white/5">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
      <Reveal className="lg:col-span-5">
        <Eyebrow>About GoGo Auto</Eyebrow>
        <h2 className="font-display font-extrabold uppercase text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none">
          The shop that <span className="text-ember">comes to you</span>
        </h2>
        <div className="mt-8 overflow-hidden rounded-sm border border-white/10">
          <img
            src={IMAGES.diagnostics}
            alt="Licensed 310S mobile mechanic performing on-site car diagnostics in Scarborough"
            className="w-full h-72 object-cover"
            loading="lazy"
          />
        </div>
      </Reveal>

      <Reveal delay={0.15} className="lg:col-span-7 lg:pt-14">
        <div className="space-y-6 text-base text-[#C9D2DC] leading-relaxed max-w-2xl">
          <p>
            GoGoAuto Mobile Repair &amp; Service is a fully mobile automotive repair company serving{" "}
            <strong className="text-white font-semibold">Scarborough and the Greater Toronto Area</strong>.
            Founded and operated by a licensed Ontario{" "}
            <strong className="text-white font-semibold">310S Automotive Service Technician</strong>, GoGo was
            built on a simple idea: expert car repair should meet you where you are — your driveway, your
            workplace, or wherever your vehicle happens to be.
          </p>
          <p>
            Every appointment is handled personally by a master technician with dealer-level diagnostic
            equipment. From complex electrical fault tracing and computerized engine scans to brakes,
            batteries, starters, alternators, and routine maintenance, each job is completed on-site with
            OEM-grade tools and transparent, upfront pricing. There are no towing fees, no shop waiting
            rooms, and no surprise line items — you approve the quote before a single wrench turns.
          </p>
          <p>
            Whether you need a pre-purchase inspection before buying a used car, a no-start diagnosis on a
            cold morning, or a full brake service while you work from home, GoGoAuto Mobile Repair &amp; Service delivers
            dealership-quality workmanship with the convenience of a house call. Off-site service and
            vehicle pick-up are also available for larger repairs.
          </p>
        </div>
        <div className="mt-10 grid grid-cols-3 gap-6 max-w-2xl" data-testid="about-stats">
          <div>
            <p className="font-display font-extrabold text-4xl sm:text-5xl text-ember">310S</p>
            <p className="font-mono2 text-[10px] tracking-[0.2em] uppercase text-mist mt-2">Licensed Master Technician</p>
          </div>
          <div>
            <p className="font-display font-extrabold text-4xl sm:text-5xl text-ember">7</p>
            <p className="font-mono2 text-[10px] tracking-[0.2em] uppercase text-mist mt-2">GTA Areas Served</p>
          </div>
          <div>
            <p className="font-display font-extrabold text-4xl sm:text-5xl text-ember">100%</p>
            <p className="font-mono2 text-[10px] tracking-[0.2em] uppercase text-mist mt-2">Mobile &amp; On-Site</p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
